<div class="page-container">
  <section>
    <div class="title-container">
      <h1 class="title">{{'MAIN.BLOG' | translate}}</h1>

      <div class="control">
        <div class="form-control">
          <ng-select
            [dropdownPosition]="'auto'"
            [items]="categoryList"
            [searchable]="false"
            [placeholder]="'Select category'"
            (change)="selectCategory($event?.id)"
            [formControl]="selectCategoryControl"
            appendTo="body"
            class="white"
          >
            <ng-template ng-label-tmp let-item="item">
              <div class="d-flex align-items-center pl-4">
                <img *ngIf="item?.icon" [src]="item?.icon" alt="">
                {{item.label | translate}}
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-index="index">
              <img *ngIf="item?.icon" [src]="item?.icon" alt="">
              {{item.label | translate}}
              <img class="selected" height="24" width="24" src="assets/img/check.svg" [alt]="''">
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="body">

      <div class="blog-list" [class.grid-column-3]="postCount >= 3">
        <div *ngFor="let post of (postsList$ | async)" class="blog-list-item">
          <a [routerLink]="localeService.getLink(routesEnum.BLOG) + '/' + post?.post_url" class="link"></a>
          <div class="img-container">
<!--            <img [src]="post?.post_preview" loading="lazy" alt="">-->
            <img [src]="post?.post_preview" alt="">

            <span class="badge"
                  [style.backgroundColor]="getCategoryBadge('background_text', post.post_category_id)"
                  [style.color]="getCategoryBadge('color_text', post.post_category_id)"
            >
               {{ getCategoryBadge('name', post.post_category_id) }}
            </span>
          </div>
          <h2 class="title">{{post?.title}}</h2>
          <div class="additional-info-container">
            <p class="descr">{{post?.createdDate | date: 'dd.MM.yyyy'}}</p>
            <img src="assets/img/arrow-small-right.svg" height="24" width="24" loading="lazy" alt="">
          </div>
        </div>
      </div>

<!--      <div *ngIf="displayPagination$ | async" class="pagination">-->
<!--        <div class="action-list">-->
<!--          <button class="btn btn-white">-->
<!--            <img src="assets/img/arrow-backward.svg" height="24" width="24" loading="lazy" alt="">-->
<!--          </button>-->
<!--          <button class="btn btn-white">-->
<!--            <img src="assets/img/arrow-left.svg" height="24" width="24" loading="lazy" alt="">-->
<!--          </button>-->
<!--        </div>-->
<!--        <div class="pagination-list">-->
<!--          <span class="pagination-list-item">1</span>-->
<!--          <span class="pagination-list-item">2</span>-->
<!--          <span class="pagination-list-item">3</span>-->
<!--          <span class="pagination-list-item">4</span>-->
<!--        </div>-->
<!--        <div class="action-list">-->
<!--          <button class="btn btn-white">-->
<!--            <img src="assets/img/arrow-left.svg" height="24" width="24" loading="lazy" alt="">-->
<!--          </button>-->
<!--          <button class="btn btn-white">-->
<!--            <img src="assets/img/arrow-backward.svg" height="24" width="24" loading="lazy" alt="">-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </section>
</div>
